import { Link } from 'react-router-dom';

export default function FoerdererWerdenPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8 text-center">
          <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
            Förderer werden
          </span>
          <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight mb-6">
            Potenzial erkennen.<br />Zukunft ermöglichen.
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto">
            Werden Sie Teil einer Bewegung, die junge Menschen nicht über ihre Schwierigkeiten definiert, 
            sondern über ihre Möglichkeiten.
          </p>
        </div>
      </section>

      {/* Fördermöglichkeiten */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Möglichkeiten
            </span>
            <h2 className="text-3xl md:text-[42px] font-bold text-gray-900 tracking-tight">
              Wie Sie unterstützen können.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-3xl mb-5">💛</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Regelmäßige Förderung</h3>
              <p className="text-gray-600 leading-relaxed">
                Unterstützen Sie asK-mi mit einem regelmäßigen Beitrag und ermöglichen Sie 
                kontinuierliche Förderarbeit.
              </p>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-3xl mb-5">🎯</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Projektförderung</h3>
              <p className="text-gray-600 leading-relaxed">
                Fördern Sie ein konkretes Projekt und erleben Sie direkt, 
                welche Wirkung Ihre Unterstützung hat.
              </p>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-3xl mb-5">🏢</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Unternehmenspartnerschaft</h3>
              <p className="text-gray-600 leading-relaxed">
                Werden Sie als Unternehmen strategischer Partner und 
                übernehmen Sie gesellschaftliche Verantwortung.
              </p>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-3xl mb-5">🎁</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Sachleistungen</h3>
              <p className="text-gray-600 leading-relaxed">
                Unterstützen Sie mit Sachleistungen, Räumlichkeiten, 
                Materialien oder Dienstleistungen.
              </p>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-3xl mb-5">🤝</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Strategische Partnerschaft</h3>
              <p className="text-gray-600 leading-relaxed">
                Werden Sie langfristiger Partner und gestalten Sie 
                gemeinsam mit uns neue Möglichkeiten.
              </p>
            </div>

            <div className="bg-white border border-[#E8E4DE] rounded-2xl p-8 hover:border-[#C4A962] hover:shadow-lg transition-all duration-300">
              <div className="text-3xl mb-5">👤</div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Persönliche Unterstützung</h3>
              <p className="text-gray-600 leading-relaxed">
                Bringen Sie Ihr Wissen, Ihre Erfahrung oder Ihr Netzwerk 
                als Mentor oder Berater ein.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Werte */}
      <section className="py-24 md:py-32 bg-[#FAF9F7]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
                Warum asK-mi
              </span>
              <h2 className="text-3xl md:text-[38px] font-bold text-gray-900 tracking-tight mb-6">
                Ihre Förderung macht den Unterschied.
              </h2>
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962] flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Transparenz</h4>
                    <p className="text-gray-600">Sie erfahren genau, wie Ihre Förderung eingesetzt wird.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962] flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Wirkung</h4>
                    <p className="text-gray-600">Jeder Beitrag schafft konkrete Möglichkeiten für junge Menschen.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962] flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Vertrauen</h4>
                    <p className="text-gray-600">Professionelle Prüfung und Begleitung jeder Förderung.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#C4A962] flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Dialog</h4>
                    <p className="text-gray-600">Regelmäßige Updates und persönlicher Austausch.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/d4ed44b3-63d8-417d-957c-4836bdf688a4/images/8c190333e75931919819da0d24d2fb6570ab5afd4583865115618ee9ddd4f709.jpeg" 
                alt="Verantwortung und Partnerschaft"
                className="w-full h-[450px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Kontakt CTA */}
      <section className="py-24 md:py-32 bg-gray-900 text-white text-center">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-[48px] font-bold tracking-tight mb-6 leading-tight">
            Potenzial erkennen.<br />Zukunft ermöglichen.
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
            Mit Ihrer Unterstützung können nicht nur einzelne Menschen gefördert werden. 
            Sie können auch Strukturen stärken, in denen Menschen füreinander da sind.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 mb-10">
            <span className="bg-white/10 px-4 py-2 rounded-full text-sm">Jugendliche fördern</span>
            <span className="bg-white/10 px-4 py-2 rounded-full text-sm">Familien unterstützen</span>
            <span className="bg-white/10 px-4 py-2 rounded-full text-sm">Selbsthilfe stärken</span>
            <span className="bg-white/10 px-4 py-2 rounded-full text-sm">Projekte ermöglichen</span>
          </div> 
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 bg-[#C4A962] hover:bg-[#D4B972] text-gray-900 px-9 py-4 rounded-md font-semibold text-lg transition-all hover:-translate-y-0.5"
            >
              asK-mi unterstützen
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
